import type { IconSvgObject } from './types';

const GoogleDriveIcon: IconSvgObject = [
  ["path", { d: "M9 3L2 16L5 21M9 3H15L22 16M9 3L12 8.4M5 21H19L22 16M5 21L7.77778 16M22 16H16.2222M7.77778 16H16.2222M7.77778 16L12 8.4M16.2222 16L12 8.4", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }]
];

export default GoogleDriveIcon;
